/* tslint:disable */
/* eslint-disable */
/**
 * SLOeats API
 * Interal API to the SLOeats platform.
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PaymentSession
 */
export interface PaymentSession {
    /**
     * 
     * @type {string}
     * @memberof PaymentSession
     */
    readonly session_url: string;
}

/**
 * Check if a given object implements the PaymentSession interface.
 */
export function instanceOfPaymentSession(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "session_url" in value;

    return isInstance;
}

export function PaymentSessionFromJSON(json: any): PaymentSession {
    return PaymentSessionFromJSONTyped(json, false);
}

export function PaymentSessionFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentSession {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'session_url': json['session_url'],
    };
}

export function PaymentSessionToJSON(value?: PaymentSession | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
    };
}

